import DeleteIcon from '@mui/icons-material/Delete'
import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material'
import { useTranslation } from 'react-i18next'

import type { ContextMenuState } from '@/features/bidding/types/bidLadderInput'

type BidLadderContextMenuProps = {
  state: ContextMenuState
  onClose: () => void
  onRemove: () => void
}

function BidLadderContextMenu({ state, onClose, onRemove }: Readonly<BidLadderContextMenuProps>) {
  const { t } = useTranslation()

  const handleRemove = () => {
    onRemove()
    onClose()
  }

  return (
    <Menu
      MenuListProps={{
        'aria-label': t('bidding.bidding_cascading.bid_ladder.context_menu_label'),
      }}
      TransitionProps={{
        timeout: 150,
      }}
      anchorPosition={state.anchorPosition ?? undefined}
      anchorReference="anchorPosition"
      open={state.anchorPosition !== null}
      slotProps={{
        paper: {
          sx: {
            boxShadow: 3,
          },
        },
      }}
      onClose={onClose}
    >
      <MenuItem
        sx={{
          transition: 'background-color 0.12s ease',
        }}
        onClick={handleRemove}
      >
        <ListItemIcon>
          <DeleteIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText
          primary={t('bidding.bidding_cascading.bid_ladder.remove_from_level')}
          secondary={state.group?.code}
        />
      </MenuItem>
    </Menu>
  )
}

export default BidLadderContextMenu
